import React from 'react'

import * as yup from 'yup'
import { Formik } from 'formik'

import FormWrapper from '../../../components/FormWrapper/FormWrapper'
import FormSection from '../../../components/FormSection/FormSection'
import FormInputsEn from './FormInputsEn'
import FormInputsSr from './FormInputsSr'
import FormInputs from './FormInputs'

const HistoryForm = ({ initialValues, onSubmit, onDelete, language, isEditForm = false }) => {
    const payloadSchema = yup.object().shape({
        year: yup.string().required(),
        historyTextEn: yup.string().required(),
        historyText: yup.string().required(),
    })

    const _historyForm = (props) => {
        return (
            <FormSection
                {...props}
                FormInputsEn={FormInputsEn}
                FormInputsSr={FormInputsSr}
                FormInputs={FormInputs}
                isEditForm={isEditForm}
                onDelete={onDelete}
            />
        )
    }

    return (
        <FormWrapper>
            <Formik
                initialValues={initialValues}
                enableReinitialize
                validationSchema={payloadSchema}
                onSubmit={onSubmit}
            >
                {_historyForm}
            </Formik>
        </FormWrapper>
    )
}

export default HistoryForm
